<header nx-header>
  <nx-header-brand>
    <nx-link>
      <a [routerLink]="'/' + (activeLineOfBusiness ?? '')">
        <img
          ngSrc="assets/allianz_logo.svg"
          width="120"
          height="31"
          alt="Allianz"
          [attr.aria-label]="'header.home.accessibility-label' | translate"
        />
      </a>
    </nx-link>
    <nx-header-app-title data-testid="app-title">{{ 'header.title' | translate }}</nx-header-app-title>
  </nx-header-brand>
  <div class="flex flex-row">
    @if (isLineOfBusinessEnabled()) {
      <kyc-line-of-business-selector (lineOfBusinessEmitter)="(activeLineOfBusiness)" />
    }
    <kyc-business-unit-selector />
    <div class="flex flex-row align-middle items-center">
      @if (isLocaleSelectorEnabled()) {
        <kyc-locale-selector class="mr-5" />
      }
      @if (gadId) {
        {{ 'header.logged-in-as' | translate: { gadId } }}
      }
    </div>
  </div>
</header>
